// Translated
// Migrated
<template>
  <div
    class="form-container-blue border-blue"
    :class="containerClass"
  >
    <div
      class="traveler-title"
      :class="titleClass"
    >
      <slot name="title" />
    </div>
    <div :class="contentClass">
      <slot name="content" />
    </div>
    <slot name="append" />
  </div>
</template>

<script>
export default defineNuxtComponent({
  props: {
    containerClass: {
      type: String,
      default: 'my-4 p-0',
    },

    titleClass: {
      type: String,
      default: 'mb-4 px-12',
    },

    contentClass: {
      type: String,
      default: 'py-4 px-6',
    },
  },
})
</script>
